
import {
  send as logSend
} from 'smith-log'

export default {
  name: 'Job',
  props: {
    job: Object,
    mode: String
  },
  data() {
    return {
      defaultImg: 'this.src="' + require('~/assets/img/grey_avatar.png') + '"',
      visible: false,
      title: 'Get Hirey App',
      content: 'Scan the QR code to download Hirey APP Chat with recruiter directly right now!'
    }
  },
  methods: {
    chatMC() {
      // this.visible = true
      location.href = `/job/${this.job.id}`
      logSend('MC','e_ca_website_start_chatting_button', {
        job_id: this.job.id,
        recruiter_id: this.job.recruiter.id,
        page_id: 'p_ca_website_job_detail'
      })
    },
    likeMC() {
      this.visible = true
      logSend('MC','e_ca_website_save_job_button', {
        job_id: this.job.id,
        recruiter_id: this.job.recruiter.id,
        page_id: 'p_ca_website_job_detail'
      })
    }
  }
};
